export const PRODUCT_DISPLAY_MODE_KEY = 'agm-product-display-mode'

export const PRODUCT_DISPLAY_MODES = ['classic', 'essential']

const safely = fn => {
  try {
    return fn()
  } catch {
    return null
  }
}

export const isProductDisplayMode = value =>
  PRODUCT_DISPLAY_MODES.includes(value)

export const readProductDisplayMode = () => {
  if (typeof window === 'undefined') return null
  const value = safely(() =>
    window.localStorage.getItem(PRODUCT_DISPLAY_MODE_KEY)
  )
  return isProductDisplayMode(value) ? value : null
}

export const writeProductDisplayMode = mode => {
  if (typeof window === 'undefined' || !isProductDisplayMode(mode)) return
  safely(() => window.localStorage.setItem(PRODUCT_DISPLAY_MODE_KEY, mode))
}
